// extracted by mini-css-extract-plugin
export default {"container":"container__55c70db0","product_list":"product_list__55c70db0"};